var MysaerrlogsDetailsController = (function () {
    function MysaerrlogsDetailsController(settings, env, $compile, $filter, socket, $scope, $state, $stateParams, $http, Dialog, notify) {
        var _this = this;
        this.settings = settings;
        this.env = env;
        this.$compile = $compile;
        this.$filter = $filter;
        this.socket = socket;
        this.$scope = $scope;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$http = $http;
        this.Dialog = Dialog;
        this.notify = notify;
        this.table = { sortType: '', sortReverse: false, search: '', filter: false, filterParams: {} };
        this.options = { oneSelected: false, selected: {} };
        this.countFired = false;
        this.isDetailsOpen = true;
        this.id = '';
        this.failedQueue = [];
        this.backendModuleName = 'admin/mysaerrors/mysaerr-logs';
        this.scopePrefix = 'admin.mysaerrors';
        this.scopeGetOppLogs = this.scopePrefix + ".getMysaErrLogs";
        this.scoperesolveOppLogs = this.scopePrefix + ".resovleMysaErr";
        this.id = $stateParams.id;
        this.dataLoaded = false;
        this.socket.forward(this.scopeGetOppLogs, this.$scope);
        this.$scope.$on("socket:" + this.scopeGetOppLogs, function (event, data) {
            if (data.items) {
                _this.failedQueue = data.items[0].errors;
            }
        });
        this.socket.forward(this.scoperesolveOppLogs, this.$scope);
        this.$scope.$on("socket:" + this.scoperesolveOppLogs, function (event, data) {
            if (data.message) {
                _this.dataLoaded = false;
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        data: { id: _this.id },
                        email: _this.env.user.email,
                        function: 'getMysaErrLogs',
                        scopeBack: _this.scopeGetOppLogs,
                        script: _this.backendModuleName,
                        token: _this.env.user.token
                    }
                });
            }
        });
    }
    MysaerrlogsDetailsController.prototype.handleDetailsClick = function (index) {
        this.isDetailsOpen = this.isDetailsOpen === index ? false : index;
    };
    MysaerrlogsDetailsController.prototype.handleResolveClick = function (errorId) {
        this.dataLoaded = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {
                    id: this.id,
                    errId: errorId
                },
                function: 'resovleMysaErr',
                script: this.backendModuleName,
                token: this.env.user.token
            }
        });
    };
    MysaerrlogsDetailsController.prototype.getJsonInbound = function (inbound) {
        return JSON.stringify(inbound).replace(/,/gi, '",\n\n').replace(/},/gi, '\n},\n\n').replace(/{/gi, '\n{\n\n');
    };
    MysaerrlogsDetailsController.prototype.$onInit = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: { id: this.id },
                email: this.env.user.email,
                function: 'getMysaErrLogs',
                scopeBack: this.scopeGetOppLogs,
                script: this.backendModuleName,
                token: this.env.user.token
            }
        });
    };
    MysaerrlogsDetailsController.$inject = [
        'settings',
        'env',
        '$compile',
        '$filter',
        'socket',
        '$scope',
        '$state',
        '$stateParams',
        '$http',
        'Dialog',
        'notify'
    ];
    return MysaerrlogsDetailsController;
}());
var MysaerrlogsDetailsComponent = (function () {
    function MysaerrlogsDetailsComponent() {
        this.templateUrl = 'mysaerrlogs-details.html';
        this.controllerAs = 'vm';
        this.controller = MysaerrlogsDetailsController;
    }
    return MysaerrlogsDetailsComponent;
}());
angular
    .module('application')
    .component('mysaerrlogsDetailsSection', new MysaerrlogsDetailsComponent());

//# sourceMappingURL=mysaerrlogs-details.component.js.map
